import type { RpcMethodParameters } from '@scayle/storefront-nuxt'
import type { RpcOptions } from '../types/rpc'

type Options = Partial<{
  params: MaybeRefOrGetter<RpcMethodParameters<'getProductAlternateNames'>>
  options: RpcOptions
  key: string
}>

export default ({
  key = 'useProductAlternateNames',
  params,
  options,
}: Options) => {
  const { data, refresh, status } = useRpc(
    'getProductAlternateNames',
    key,
    params,
    options,
  )
  return { data, refresh, status }
}
